import React, { useState } from 'react'

// Filters are hidden for now — the screen real estate is used for rotation.
// const FILTERS = [
//   { id: 'color', label: 'Color' },
//   { id: 'grayscale', label: 'Gray' },
//   { id: 'bw', label: 'B&W' },
// ]

export default function ReviewScreen({ pages, uploading, onBack, onDelete, onMove, onRotate, onEditCrop, onSend }) {
  const [selectedId, setSelectedId] = useState(pages[0]?.id ?? null)
  const selected = pages.find((p) => p.id === selectedId) || pages[0]
  const idx = pages.indexOf(selected)

  if (!pages.length) {
    return (
      <div className="review empty">
        <p>No pages yet.</p>
        <button className="btn btn-primary" onClick={onBack}>Scan</button>
      </div>
    )
  }

  return (
    <div className="review">
      <div className="review-main">
        <img src={selected.processedDataUrl} alt={`Page ${idx + 1}`} />
      </div>

      <div className="filter-row">
        {/* {FILTERS.map((f) => (
          <button
            key={f.id}
            className={'btn btn-small' + (selected.filter === f.id ? ' btn-active' : '')}
            onClick={() => onFilter(selected.id, f.id)}
          >
            {f.label}
          </button>
        ))} */}
        <button className="btn btn-small" onClick={() => onRotate(selected.id, -90)} aria-label="Rotate left">
          ↺ Rotate left
        </button>
        <button className="btn btn-small" onClick={() => onRotate(selected.id, 90)} aria-label="Rotate right">
          ↻ Rotate right
        </button>
        <button className="btn btn-small" onClick={() => onEditCrop(selected.id)}>Adjust crop</button>
        <button className="btn btn-small btn-danger" onClick={() => { onDelete(selected.id); setSelectedId(null) }}>
          Delete
        </button>
      </div>

      <div className="thumb-strip">
        {pages.map((p, i) => (
          <div key={p.id} className={'thumb' + (p.id === selected.id ? ' thumb-selected' : '')}>
            <img src={p.processedDataUrl} alt={`Page ${i + 1}`} onClick={() => setSelectedId(p.id)} />
            <div className="thumb-actions">
              <button disabled={i === 0} onClick={() => onMove(p.id, -1)} aria-label="Move left">‹</button>
              <span>{i + 1}</span>
              <button disabled={i === pages.length - 1} onClick={() => onMove(p.id, 1)} aria-label="Move right">›</button>
            </div>
          </div>
        ))}
      </div>

      <div className="controls">
        <button className="btn" onClick={onBack} disabled={uploading}>+ Scan more</button>
        <button className="btn btn-primary" disabled={uploading} onClick={onSend} data-testid="send-button">
          {uploading ? 'Sending…' : `Send to Robot Accounts (${pages.length})`}
        </button>
      </div>
    </div>
  )
}
